import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "header-title" }
const _hoisted_2 = ["src"]

import {computed, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {menuItems, MenuItem} from './layout_data';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'app_layout',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentExternalUrl = ref<string | null>(null);

const activeMenu = computed(() => {
    return route.path || '/';
});

const currentTitle = computed(() => {
    const item = menuItems.find(i => i.path === route.path || (i.isExternal && i.externalUrl === currentExternalUrl.value));
    return item?.name || '首页';
});

const getIcon = (iconName: string) => {
    return (ElementPlusIconsVue as any)[iconName] || ElementPlusIconsVue.Menu;
};

const handleMenuClick = (item: MenuItem) => {
    if (item.isExternal && item.externalUrl) {
        currentExternalUrl.value = item.externalUrl;
    } else if (item.path) {
        currentExternalUrl.value = null;
        router.push(item.path);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "app-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, {
        width: "200px",
        class: "aside"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo-container" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "logo"
            }),
            _createElementVNode("span", { class: "logo-text" }, "退费平台")
          ], -1)),
          _createVNode(_component_el_menu, {
            "default-active": activeMenu.value,
            mode: "vertical",
            "background-color": "#304156",
            "text-color": "#bfcbd9",
            "active-text-color": "#409EFF"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
                return (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: item.name,
                  index: item.path || item.name,
                  onClick: ($event: any) => (handleMenuClick(item))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["index", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "main-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { class: "header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(currentTitle.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, {
            class: _normalizeClass(['main', { 'no-scrollbar': currentExternalUrl.value }])
          }, {
            default: _withCtx(() => [
              (!currentExternalUrl.value)
                ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                : (_openBlock(), _createElementBlock("iframe", {
                    key: 1,
                    src: currentExternalUrl.value,
                    class: "external-iframe",
                    frameborder: "0"
                  }, null, 8, _hoisted_2))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})